import { render, staticRenderFns } from "./ColumnForm.vue?vue&type=template&id=9d60239c&scoped=true&"
import script from "./ColumnForm.vue?vue&type=script&lang=js&"
export * from "./ColumnForm.vue?vue&type=script&lang=js&"
import style0 from "./ColumnForm.vue?vue&type=style&index=0&id=9d60239c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d60239c",
  null
  
)

export default component.exports